import VSLRow from "./VSLRow";

export default class VSLLabelRow extends VSLRow {

    constructor(id, label = null, value = null, valueType = "string") {
        super(id, "label");

        this.label = label;
        this.value = value;
        this.valueType = valueType;
    }
}